import { useEffect, useRef } from "react";
import { isFeatureEnabled } from "@utils/configurationUtils";
import { ToolbarMetricName } from "@constants/logging";
import { useGetLogger } from "@hooks/useGetLogger";

function useClipboardPermissions() {
    const log = useGetLogger();

    const prevStateRef = useRef(null);

    const clipboardPermissionsReloadFlag = isFeatureEnabled(
        "clipboardPermissionReload"
    );

    useEffect(() => {
        const checkClipboardPermission = async () => {
            try {
                const status = await navigator.permissions.query({
                    name: "clipboard-read" as PermissionName,
                });
                prevStateRef.current = status.state;

                log.logMessage(`Clipboard permission: ${status.state}`);

                const onChange = (event) => {
                    const newStatus = event.target;
                    const prevState = prevStateRef.current;

                    prevStateRef.current = newStatus.state;

                    log.logMessage(
                        `Clipboard permission changed: ${status.state}`
                    );

                    if (
                        clipboardPermissionsReloadFlag &&
                        !(
                            prevState === "prompt" &&
                            newStatus.state === "denied"
                        ) &&
                        newStatus.state !== "prompt"
                    ) {
                        window.location.reload();
                    }
                };

                status.addEventListener("change", onChange);

                return () => {
                    status.removeEventListener("change", onChange);
                };
            } catch (error) {
                log.logMessage(`Error checking clipboard permission: ${error}`);
                log.publishCounterMetric(
                    ToolbarMetricName.GET_CLIPBORAD_BROWSER_PERMISSION_ERROR
                );
            }
        };

        void checkClipboardPermission();
    }, []);
}

export default useClipboardPermissions;
